module.exports = __webpack_public_path__ + "img/12.6ff6a5ec.png";